module.exports = __webpack_public_path__ + "media/theme/bg__sale-e51dfa03.svg";